import ValidatePage from '@/router/modules/methods/validate'
import clear_all_videos from "@/router/modules/methods/clear_all_videos";

export default {
    path: '/survey',
    name: 'Survey',
    component: () => import('@/views/survey/index.vue'),
    meta: {
        title: 'Заказ съемки',
        forVisitors: true
    },
    beforeEnter: async (to, from, next) => {
        await clear_all_videos()
        await ValidatePage(next)
    }
}